// @flow
import cn from 'classnames';
import React from 'react';

import type { ILayoutEnum } from '../layout';
import type { FiveSymbolLocale } from '@site-builder/common/src/types/locale';

import logoutIcon from '../../../../assets/images/icons/user-logout.svg';
import { getUserAccountLogoutText } from '../../../../utils/translation';

import './style.pcss';

type Props = {|
  layout: ILayoutEnum,
  locale: FiveSymbolLocale,
  onClick: () => void,
  isShow: boolean
|}

const LogoutButton = ({
  layout,
  locale,
  onClick,
  isShow
}: Props) => (
  <button
    className={cn('logout-button',
      `logout-button-${layout}`,
      { [`logout-button-${layout}--shown`]: isShow })}
    onClick={onClick}
  >
    <span
      className='logout-button__text'
    >
      {getUserAccountLogoutText(locale)}
    </span>
    <div
      className='logout-button__icon'
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: logoutIcon }}
    />
  </button>
);

export default LogoutButton;
